import './InputComponent.scss'
import React from "react";

interface InputComponentProps {
    label: string,
    value: string,
    onChange: (value: string) => void,
    placeholder?: string,
    disabled?: boolean,
    type?: string,
    labelClass?: string,
    inputClass?: string,
    labelWidth?: string,
    inputWidth?: string,
    maxLength?: number,
    digitsOnly?: boolean,
    onlyUppercase?: boolean
}

export const InputComponent: React.FC<InputComponentProps> = (
    {
        label,
        value,
        onChange,
        disabled,
        type,
        placeholder,
        labelClass,
        inputClass,
        maxLength,
        digitsOnly,
        onlyUppercase
    }: InputComponentProps) => {

    const onDateChange = (value: string) => {
        const values = value.split("/")
        let finalValue = ""
        if (values.length !== 0) {
            const days = values[0].replace(/\D/g,'')
            if (days.length < 2 && values[1] && values[2]) {
                finalValue = days + "/" + values[1] + "/" + values[2]
            } else {
                if ((days.length <= 2 && Number(days) > 31) || (days.length === 3 && Number(days[2]) > 1)) {
                    if (days.length <= 2 && Number(days) > 31) {
                        finalValue = ""
                    } else {
                        finalValue = days.substring(0, 2)
                    }

                } else {
                    if (days.length <= 3) {
                        if (days.length === 2 && values[1]) {
                            finalValue += days + "/"
                        } else if (days.length === 3) {
                            finalValue += days.substring(0, 2) + "/" + days.substring(2)
                        } else if (days && values[2]) {
                            finalValue += days + "//"
                        } else {
                            finalValue += days
                        }
                    }
                }
                if (values[1]) {
                    const month = values[1].replace(/\D/g,'')
                    if (month.length < 2 && values[2]) {
                        finalValue = days + "/" + month + "/" + values[2]
                    } else {
                        if ((month.length <= 2 && Number(month) > 12) || (month.length === 3 && Number(month[2]) > 2)) {
                            return days
                        } else {
                            if (month.length <= 3) {
                                if (month.length === 2 && values[2]) {
                                    finalValue += month + "/"
                                } else if (month.length === 3) {
                                    finalValue += month.substring(0, 2) + "/" + month.substring(2)
                                } else {
                                    finalValue += month
                                }

                            }

                        }
                        if (values[2]) {
                            const year = values[2].replace(/\D/g,'')
                            if (year.length <= 4) {
                                finalValue += year
                                if (year.length === 4) {
                                    const monthLastDay = new Date(Number(year), Number(month), 0).getDate()
                                    if (Number(monthLastDay) < Number(days)) {
                                        finalValue = monthLastDay + finalValue.slice(2)
                                    }
                                }
                            }
                            if (year.length > 4) {
                                finalValue += year.substring(0, 4)
                            }
                        }
                    }

                } else if (values[2]) {
                    finalValue += values[2]
                }
            }

        }
        onChange(finalValue)
    }

    const onValueChange = (value: string) => {
        if (digitsOnly) {
            onChange(value.replace(/\D/g,''))
        } else {
            if (onlyUppercase) {
                onChange(value.toUpperCase())
            } else {
                onChange(value)
            }
        }
    }

    return (
        <div className="input-container">
            <div className={`${labelClass ? labelClass : ''} font-sm input-label flex-start primary-color`}>
                {label}
            </div>
            {type !== 'date' ? (
                <input
                    type={`${type ? type : 'text'}`}
                    inputMode={digitsOnly ? "numeric": "text"}
                    className={`${inputClass ? inputClass : ''} font-md-plus primary-font-color input full-border-radius 
                    secondary-color-border ${onlyUppercase ? 'only-uppercase' : ''} ${disabled ? 'no-pointer-events disabled' : ''}`}
                    maxLength={maxLength ? maxLength : 524288}
                    value={value}
                    onChange={(event) => onValueChange(event.target.value)}
                    placeholder={placeholder}
                />
            ) : (
                <input
                    type="text"
                    inputMode="numeric"
                    className={`${inputClass ? inputClass : ''} font-md-plus primary-font-color input full-border-radius full-border secondary-color-border`}
                    value={value}
                    maxLength={10}
                    onChange={(event) => onDateChange(event.target.value)}
                    placeholder={placeholder}
                />
        )}

        </div>
    )
}